export class CustomDialogConfig<D = any> {
    data?: D;
    action?;
}
